import React, { useState, useEffect } from 'react';
import { Form, Button, InputGroup, Alert, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate, Link } from 'react-router-dom';
import { post, get } from '../utils/api';
import config from '../config';
import { useToast } from './ToastContext';
import './Login.css';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const rememberedIdentifier = localStorage.getItem('rememberedIdentifier');
    if (rememberedIdentifier) {
      setIdentifier(rememberedIdentifier);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      const data = await post('/auth/login', { identifier, password });

      localStorage.setItem('token', data.access_token);
      localStorage.setItem('refreshToken', data.refresh_token);

      if (rememberMe) {
        localStorage.setItem('rememberedIdentifier', identifier);
      } else {
        localStorage.removeItem('rememberedIdentifier');
      }

      const profile = await get('/auth/profile');
      showToast(`Welcome, ${profile.data.name}!`, 'success');

      if(onLogin) onLogin();
      navigate('/dashboard');
    } catch (error) {
      setError(error.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  // const handleGoogleLogin = () => {
  //   // Placeholder for Google login logic
  // };

  return (
    <div className="med-login-wrapper">
      <div className="med-login-card">
        <div className="med-login-left">
          <div className="med-left-content">
            <div className="med-logo">
              <div className="pill"></div>
              <h5>{config.appName}</h5>
            </div>
            <p className="med-tagline">
              Empowering Healthcare, One Click at a Time. Your Health, Your Records, Your Control.
            </p>
          </div>
        </div>
        <div className="med-right">
          <div className="med-form">
            <h3>Login</h3>
            <p className="subtitle">Log in to your account.</p>

            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  required
                  disabled={loading}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </Button>
                </InputGroup>
              </Form.Group>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Form.Check 
                  type="checkbox"
                  label="Remember me"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  disabled={loading}
                />
                <Link to="/forgot-password" className="forgot">Forgot Password?</Link>
              </div>
              
              <Button className="login-btn" type="submit" disabled={loading}>
                {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Log In'}
              </Button>
              
              {/* <Button variant="outline-secondary" className="google-btn" onClick={handleGoogleLogin}>
                <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="google" />
                Log in with Google
              </Button>
              
              <p className="signup">
                Don’t have an account? <span>Sign Up</span>
              </p> */}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;